// extracted by mini-css-extract-plugin
export default {"checking-history":"CheckingHistory_checking-history__YnWF4","checking-history-item":"CheckingHistory_checking-history-item__mqi4-","accordion":"CheckingHistory_accordion__xIqyd"};